
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { Router, RouterModule } from '@angular/router';
import { PasswordService } from '../../services/password/password.service';

@Component({
  selector: 'app-forgot-password',
  imports: [
    MatFormFieldModule,
    MatCardModule,
    MatInputModule,
    ReactiveFormsModule,
    MatButtonModule,
    RouterModule
],
  templateUrl: './forgot-password.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  /** Form builder service */
  private fb = inject(FormBuilder);

  /** Forgot password form */
  forgotPasswordForm: FormGroup;

  /** Error message */
  errorMessage: string = "";

  /** Success message */
  successMessage: string = "";

  /** Status on form submission */
  isSubmitting: boolean = false;

  /**
   * Default constructor to initialize the form
   */
  constructor(
    private router: Router,
    private passwordService: PasswordService,
  ) {
    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      ssnLast4: ['', [Validators.required, Validators.pattern(/^\d{4}$/)]],
      dateOfBirth: ['', Validators.required]
    });
  }

  /**
   * Handles form submission
   */
  onSubmit(): void {
    if (!this.forgotPasswordForm.valid || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    this.errorMessage = "";
    this.successMessage = "";

    const email = this.forgotPasswordForm.value.email;
    const ssnLast4 = this.forgotPasswordForm.value.ssnLast4;
    const dateOfBirth = this.forgotPasswordForm.value.dateOfBirth;
    this.passwordService.sendForgotPasswordRequest(email, ssnLast4, dateOfBirth).subscribe({
      next: () => {
        console.log('[FORGOT-PASSWORD]: Request sent successfully');
        this.successMessage = 'Password reset instructions have been sent to your email address.';
        this.isSubmitting = false;

        // Redirect to login after a delay
        setTimeout(() => {
          this.router.navigate(['/login']);
        }, 3000);
      },
      error: (error) => {
        console.error('[FORGOT-PASSWORD]: Request failed:', error);
        this.errorMessage = error.error?.message || 'Failed to send password reset instructions. Please try again.';
        this.isSubmitting = false;
      }
    });
  }

  /**
   * Navigate back to login
   */
  goBack(): void {
    this.router.navigate(['/login']);
  }
}
